<template>
<div style="margin-bottom:3rem">

  <!-- DIALO  WITH OPTIONS  -->
  <v-dialog :class="{'filtr-active':showFilter}" width="1000" v-model="show">
    <v-btn block color="primary" slot="activator">
      {{ $t('archive.filter.new_filter') }}
    </v-btn>
    <v-card>
      <v-card-title class="headline" primary-title>
        {{ $t('archive.filter.new_filter') }}
      </v-card-title>
      <v-container>
        <v-flex xs8>
          <v-text-field v-model="name" :label="`${$t('archive.name')}`" required></v-text-field>
        </v-flex>
        <div>
          <div>
            <h3> {{ $t('archive.filter.contains') }} : </h3>
            <div :key="i" v-for="i in rangeContains">
              <v-layout>
                <v-flex v-if="i!=1" xs5 sm3>
                  <v-select  style="margin-left:2rem;" prepend-icon="xxyyzz" :items="operators" item-text="name" item-value="value" v-model="operatorsContains[i]" :label="`${$t('archive.filter.operator')}`"></v-select>
                </v-flex>
                <v-flex xs5 sm3>
                  <v-text-field  style="margin-left:2rem;" v-model="searchContains[i]" prepend-icon="search" :label="`${$t('archive.filter.phrase')}`" required></v-text-field>
                </v-flex>
                <v-flex xs2 sm1>
                  <v-btn v-if="i!=1" style="margin-left:2rem;" fab small block @click="removeFiltrContains(i)">
                    <v-icon small>remove</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex v-if="i==rangeContains" xs2 sm2>
                  <v-btn fab small @click="rangeContains++">
                    <v-icon small>add</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </div>

          <div>
            <h3> {{ $t('archive.filter.not_contains') }} : </h3>
            <div :key="i" v-for="i in rangeNot">
              <v-layout>
                <v-flex v-if="i!=1" xs5 sm3>
                  <v-select  style="margin-left:2rem;" prepend-icon="xxyyzz" :items="operators" item-text="name" item-value="value" v-model="operatorsNot[i]" :label="`${$t('archive.filter.operator')}`"></v-select>
                </v-flex>
                <v-flex xs5 sm3>
                  <v-text-field  style="margin-left:2rem;" v-model="searchNot[i]" prepend-icon="search" :label="`${$t('archive.filter.phrase')}`" required></v-text-field>
                </v-flex>
                <v-flex xs2 sm1>
                  <v-btn v-if="i!=1" style="margin-left:2rem;" fab small block @click="removeFiltrNot(i)">
                    <v-icon small>remove</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex v-if="i==rangeNot" xs2 sm2>
                  <v-btn fab small @click="rangeNot++">
                    <v-icon small>add</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </div>

        <!--  FILTRACJA   -->
        <v-layout style="margin-top:1rem">
          <v-flex xs4>
            <v-text-field v-model="type" :label="`${$t('archive.arch_type')}`" required></v-text-field>
          </v-flex>
        </v-layout>

        <v-btn @click="save">
          {{ $t('archive.filter.save') }}
        </v-btn>

        <!-- KONIEC FILTRACJI -->
      </v-container>
    </v-card>
  </v-dialog>
  <!-- END DIALOG -->

</div>
</template>

<script>

export default {
  components: {

  },
  computed: {
    options() {
      return {
        theme: {
          mode: this.$store.getters.darkTheme ? 'dark' : 'light'
        },
      }
    },
  },
  data() {
    return {
      name: "",
      show: false,
      type:"",
      searchContains: [],
      rangeContains: 1,
      operatorsContains: [],
      searchNot: [],
      rangeNot: 1,
      operatorsNot: [],
      createFiltrer: true,
      sort: 1,
      place: 2,
      showFilter: false,
      operators: [{
          name: "AND",
          value: "AND"
        },
        {
          name: "OR",
          value: "OR"
        }
      ],
      filters: [],
      baseFilter: [{
        name: this.$t('archive.filter.new'),
        id: 0
      }],
      choosenFilter: 0
    }
  },
  methods: {
    removeFiltrContains(index) {
      this.operatorsContains.splice(index, 1);
      this.searchContains.splice(index, 1)
      this.rangeContains--;
    },
    removeFiltrNot(index) {
      this.operatorsNot.splice(index, 1);
      this.searchNot.splice(index, 1)
      this.rangeNot--;
    },
    buildCondition() {
      let condition = {
        "name": this.name,
        "type": this.type
      }
      condition["contains"] = this.buildConditionFromData(this.searchContains, this.operatorsContains, this.rangeContains)
      condition["not"] = this.buildConditionFromData(this.searchNot, this.operatorsNot, this.rangeNot)
      return condition
    },
    buildConditionFromData(search, operatos, range) {
      let condition = []

      for (let i = 0; i <= range; i++) {
        if (search[i] == undefined || (operatos[i] == undefined && i > 1)) { // Ignore if search is empty or operator is empty when is needed (any field axcept first)
          continue;
        }
        let objCondition = {
          "id": i,
          search: search[i]
        }

        if (i > 1) {
          objCondition.operator = operatos[i]
        }
        condition.push(objCondition)
      }
      return condition
    },
    save() {
      let filters = this.buildCondition();
      if ((Object.keys(filters.contains).length > 0 || Object.keys(filters.not).length > 0 || this.type!="") && this.name.length > 3) {
          this.$store.dispatch('createArchiveFilter',filters).then(data => {
          this.show = false
          this.clearConditions()
          this.showMessage(this.$t('archive.filter.created'), "success")
          this.$emit('filter', data)
        }).catch(() => {
          this.showMessage(this.$t('archive.filter.cannot_create'), "danger")
        })
      } else {
        this.showMessage(this.$t('archive.filter.invalid_form'), "danger")
      }
    },
    clearConditions() {
      this.searchNot = []
      this.rangeNot = 1;
      this.operatorsNot = []

      this.searchContains = []
      this.rangeContains = 1;
      this.operatorsContains = []
    },
    showMessage(text, color) {
      this.$store.commit("setSnack", {
        message: text,
        color: color,
      })
    }
  },
  created() {
  }
}
</script>

<style>
.loading-circle {
  margin: 20px;
}

.apexcharts-canvas.dark {
  background: transparent !important;
}

.filtr-active {
  background-color: green !important;
}
</style>
